import React, { memo } from 'react';
import { addOnlineForm, clearDefaultForm } from 'actions';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';

class DefaultFormDisplay extends React.Component {
  componentDidMount() {
    this.onAddForm();
  }

  onAddForm() {
    const { dispatch, formType } = this.props;
    const legalEntity = {
      id: 1
    };

    if (formType == null) {
      return;
    }

    if (this.validateDefaultFormChoice()) {
      dispatch(addOnlineForm(formType, legalEntity));
    } else {
      dispatch(clearDefaultForm());
    }
  }

  validateDefaultFormChoice() {
    const { formType, availableFormTypes } = this.props;
    return formType && availableFormTypes && availableFormTypes.includes(formType.toLowerCase());
  }

  render() {
    return '';
  }
}

DefaultFormDisplay.propTypes = {
  dispatch: PropTypes.func.isRequired,
  formType: PropTypes.string,
  availableFormTypes: PropTypes.arrayOf(PropTypes.string)
};

DefaultFormDisplay.defaultProps = {
  formType: null,
  availableFormTypes: []
};

const getFormTypes = (config) => {
  if (!config) {
    return [];
  }

  return (config.formTypes || []).map(item => item.formType);
};

function mapStateToProps(state) {
  const {
    app: { onlineConfig }
  } = state;

  return {
    formType: onlineConfig && onlineConfig.defaultFormType && onlineConfig.defaultFormType.toLowerCase(),
    availableFormTypes: getFormTypes(onlineConfig)
  };
}

const mapDispatchToProps = dispatch => ({ dispatch });

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(memo(DefaultFormDisplay));
